import React from 'react'

const SignUp = () => {
  return (
    <div>
      Sign up
    </div>
  )
}

export default SignUp
